import React, { useState, useCallback } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ResponsiveNav from '../components/navigation/navigation'; // Adjust the import path
import FavouriteHeader from '../components/FavouriteHeader/FavouriteHeader'; // Adjust the import path
import OrderCard from '../components/OrderCard/OrderCard'; // Adjust the import path
import TabPanel from '../components/CheckoutSidebar/TabPanel';
// import { courses } from '../data/StaticDatas';
import TrackingSidebar from '../components/TrackingSidebar/TrackingSidebar';
import ReusableDrawer from '../components/CheckoutSidebar/ReusableDrawer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWindowResize } from '../hooks/useWindowResize';
import { useGet } from '../hooks/useApi';


const CoursesFavourite = () => {
  const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer');
  const customerId = validateCustomer?.data.customerId
  const { data: getCourseFavorite, isLoading} = useGet(`/api/Courses/favorites/${customerId}`);
  const favoriteCard = getCourseFavorite?.data
console.log(favoriteCard);

  const [openModal, setOpenModal] = useState(false)
  const [openDrawer] = useState(false);
 
  const [openCourseDrawer, setOpenCourseDrawer] = useState(false)
  const [drawerType, setDrawerType] = useState(null); 
const location = useLocation();
const navigate = useNavigate();


const MOBILE_BREAKPOINT = 768;

const handleBreakpointChange = useCallback((newBreakpoint, width) => {
  // Ensure width is a number
  const numericWidth = typeof width === 'number' ? width : window.innerWidth;
  
  console.log('Breakpoint changed:', {
    newBreakpoint,
    width: numericWidth,
    isMobile: numericWidth < MOBILE_BREAKPOINT,
    currentPath: location.pathname
  });

  const isCheckoutCourseForm = location.pathname === '/product/course-details/checkout-form';
  const isCourseDetails = location.pathname === `/product/course-details`;
  const isCheckoutGiftForm = location.pathname === '/product/gift-details/checkout-form';
  const isGiftDetails = location.pathname === `/product/gift-details`;

  // Debug log before navigation
  // console.log('Navigation check:', {
  //   newBreakpoint,
  //   isCheckoutGiftForm,
  //   isGiftDetails,
  //   shouldNavigateToCourseCheckout: newBreakpoint === 'mobile' && isCheckoutCourseForm,
  //   shouldNavigateToCourseDetails: newBreakpoint === 'desktop' && isCourseDetails,
  //   shouldNavigateToGiftCheckout: newBreakpoint === 'mobile' && isCheckoutGiftForm,
  //   shouldNavigateToGiftDetails: newBreakpoint === 'desktop' && isGiftDetails
  // });

  if (newBreakpoint === 'mobile' && isCourseDetails) {
    console.log('Navigating to checkout form');
    navigate('/product/digital-course/favourite');
  } else if (newBreakpoint === 'desktop' && isCheckoutCourseForm) {
    console.log('Navigating to course details');
    navigate(`/product/digital-course/favourite`);
  }
  if (newBreakpoint === 'mobile' && isGiftDetails) {
    console.log('Navigating to checkout form');
    navigate('/product/giftshop/favourite');
  } else if (newBreakpoint === 'desktop' && isCheckoutGiftForm) {
    console.log('Navigating to course details');
    navigate(`/product/giftshop/favourite`);
  }
}, [location.pathname, navigate]);

const { windowWidth, isMobile } = useWindowResize(handleBreakpointChange);

  const handleCheckoutCourse = () => {
    console.log('Current path:', location.pathname);
    console.log('Is mobile:', isMobile);
    console.log('Window width:', windowWidth);
    setDrawerType('course');
    // On checkout form page
    if (location.pathname === '/product/digital-courses/favourite') {
      setOpenCourseDrawer(true);
      if (isMobile) {
        navigate(`/product/course-details/checkout-form`);
      }
    }
  };

  const handleDrawerCourseClose = () => {
    setOpenCourseDrawer(false);
    setDrawerType(null);
  };
  if (isLoading) {
    return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
  }
  return (
    <Box>
      <ResponsiveNav
        breadcrumbItems={[
          { label: 'Home', link: '/' },
          { label: 'Favourites', link: '/product/digital-courses/favourite' },
        ]}
        searchValue=""
        onSearchChange={() => {}}
        searchPlaceholder="Search..."
      />
      <FavouriteHeader cart__items={favoriteCard} />
      <Box>
        {favoriteCard?.map((item, index) => (
          <OrderCard
           title={item.courseTitle}
           image={item.courseImagePath}
           description={item.courseDescription}
            item={item}
            key={index}
            openCourseDrawer
            handleCheckoutGift={handleCheckoutCourse} // Trigger Drawer on click
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        ))}
      </Box>

      {/* Drawer for Item Details */}
      <ReusableDrawer
      state={openCourseDrawer}
      drawerType={drawerType}
      courseState={openCourseDrawer}
      onClose={handleDrawerCourseClose}
      TabPanel={TabPanel}
      setOnClose={setOpenCourseDrawer}
      title="Checkout"
      width="35%"
    />
    <TrackingSidebar open={openDrawer} onClose={handleDrawerCourseClose}/>
    </Box>
  );
};

export default CoursesFavourite;
